/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Reports Icon component.
 */
export const ReportsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.5 6.6H15.5M8.5 10.2H15.5M8.5 13.8H11.125M6.75 21H17.25C18.2165 21 19 20.1941 19 19.2V4.8C19 3.80589 18.2165 3 17.25 3H6.75C5.7835 3 5 3.80589 5 4.8V19.2C5 20.1941 5.7835 21 6.75 21Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default ReportsIcon;
